import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavigationComponent } from '../../components/navigation/navigation.component';
import { FooterComponent } from '../../components/footer/footer.component';

@Component({
  selector: 'app-landing-layout',
  standalone: true,
  imports: [RouterOutlet, NavigationComponent, FooterComponent],
  template: `
    <div class="flex flex-col h-screen overflow-hidden">
      <app-navigation></app-navigation>
      <main class="flex-1 overflow-y-auto bg-app-background-10">
        <div class="min-h-full flex flex-col bg-app-background-10">
          <div class="flex-1">
            <router-outlet></router-outlet>
          </div>
          <app-footer></app-footer>
        </div>
      </main>
    </div>
  `
})
export class LandingLayoutComponent {}
